import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
 
Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.plugin(collapse)
const GA_TAG_ID = 'YK13SHSKXJ'
const SHOPIFY_PUBLIC_STOREFRONT_KEY = '8d2b9f46c80cbf3b3cb03b7399412f6b'
const SHOPOIFY_STOREFRONT_URL = 'https://afrekenen.thuiszorgwinkelonline.nl/api/2025-01/graphql.json'
const CART_FIELDS = `
  id
  totalQuantity
  checkoutUrl
  attributes {
    key
    value
  }
  cost {
    totalAmount {
      amount
    }
  }
  lines(first: 100) {
    edges {
      node {
        id
        quantity
        cost {
          totalAmount {
            amount
          }
        }
        merchandise {
          ... on ProductVariant {
            id
            title
            sku
            price {
              amount
            }
            selectedOptions {
              name
              value
            }
            product {
              id
              title
              handle
              productType
              vendor
              featuredImage {
                cropped: transformedSrc(maxHeight: 360, maxWidth: 360, crop: CENTER)
                altText
                height
                width
                url
              }
            }
          }
        }
      }
    }
  }
`
window.Alpine = Alpine

function dataLayerPush(obj) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(obj)
}

function dataLayerEcomPush({eventName, variantFields, quantity}) {

  const obj = {
    event: eventName,
    ecommerce: {
      currencyCode: 'EUR',
      items: [
        {
          quantity: quantity,
          ...variantFields
        }
      ]
    }
  }

  if (variantFields.price && quantity) {
    obj.ecommerce.value = variantFields.price * quantity
  }

  dataLayerPush(obj)
}

window.dataLayerPush = dataLayerPush
window.dataLayerEcomPush = dataLayerEcomPush

async function getCustomAttributesWithTimeout(timeout) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Timeout'));
    }, timeout);

    getCustomAttributes().then(
      (result) => {
        clearTimeout(timer);
        resolve(result);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}

function getCookie (name, cookie) {
  const value = `; ${cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

async function getCustomAttributes () {
  try {
    const customAttributes = []
    const tagId = GA_TAG_ID;
    gtag('js', new Date());

    gtag('config', 'G-' + tagId, {
      'send_page_view': false
    });
    const clientId = await new Promise(resolve => {
      gtag('get', 'G-' + tagId, 'client_id', resolve)
    });
    const sessionId = await new Promise(resolve => {
      gtag('get', 'G-' + tagId, 'session_id', resolve)
    });

    const fbClickId = getCookie('_fbc', document.cookie)
    const fbAttribution = getCookie('_fbp', document.cookie)

    if (fbClickId) {
      customAttributes.push({
        key: '__fbc',
        value: fbClickId
      })
    }

    if (fbAttribution) {
      customAttributes.push({
        key: '__fbp',
        value: fbAttribution
      })
    }

    if (sessionId) {
      customAttributes.push({
        key: 'ga_session_id',
        value: sessionId
      })
    }

    if (clientId) {
      customAttributes.push({
        key: 'ga_client_id',
        value: clientId
      })
    }
    return customAttributes
  }
  catch(e) {
    console.log(e)
    return []
  }
}

async function shopifyRequest (query, variables) {
  const response = await fetch(SHOPOIFY_STOREFRONT_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "X-Shopify-Storefront-Access-Token": SHOPIFY_PUBLIC_STOREFRONT_KEY
    },
    body: JSON.stringify({
      query: query,
      variables: variables,
    }),
  })

  const responseJson = await response.json()

  if (responseJson.errors) {
    console.log(responseJson)
    throw new Error('Failed to fetch API')
  }

  return responseJson.data
}


Alpine.store('shop', {
  activePanel: '',
  menuItemOpen: false,
  cart: {
    totalPrice: "0.00",
    id: '',
    checkoutUrl: '',
    totalQuantity: 0,
    lines: []
  },
  init () {
    this.cart.id = window.localStorage.getItem('cartId') || ''
    if (!this.cart.id.includes('?key')) {
      this.clearCart()
    }
    this.getCart()
  },
  goToCheckout () {
    const url = this.cart.checkoutUrl
    window.dataLayer.push({
      'event' : 'begin_checkout',
      'eventCallback' : function() {
        window.location.href = url
      },
      'eventTimeout' : 2000,
      ecommerce: {
        currencyCode: 'EUR',
        value: this.cart.totalPrice,
        items: this.cart.lines.map((line) => { 
          return {
            quantity: line.node.quantity,
            ...this.variantMapFields(line.node.merchandise)
          }
        })
      }
    });
  },
  formatPrice (price) {
    const split = price.split('.')
    price = `€<span>${split[0]}</span>`
    if (split[1].length > 0 && split[1] !== '0') {
      price = price + `<sup>${split[1]}${split[1].length === 1 ? '0' : ''}</sup>`
    }
    return price
  },
  setCartValues (cart) {
    this.cart.lines = cart.lines.edges
    this.cart.totalQuantity = cart.totalQuantity
    this.cart.checkoutUrl = cart.checkoutUrl
    this.cart.totalPrice = cart.cost.totalAmount.amount
  },
  clearCart () {
    this.cart = {
      totalPrice: "0.00",
      id: '',
      checkoutUrl: '',
      totalQuantity: 0,
      lines: []
    }
    window.localStorage.removeItem('cartId')
  },
  async getCart () {
    if (this.cart.id === '') { return }
    const query = `query cart($id: ID!) {
      node(id: $id) {
        ... on Cart {
          ${CART_FIELDS}
        }
      }
    }`

    const variables = {
      id: this.cart.id,
    }

    const result = await shopifyRequest(query, variables)
    if (result.node === null) {
      this.clearCart()
      return
    }
    this.setCartValues(result.node)
  },
  async createCart () {
    const query = `mutation cartCreate {
      cartCreate {
        cart {
          id
        }
        userErrors {
          field
          message
        }
      }
    }`
    const result = await shopifyRequest(query)
    this.cart.id = result.cartCreate.cart.id
    window.localStorage.setItem('cartId', this.cart.id) 
  },
  async setAttributesAndGoToCheckout() {
    try {
      const query = `mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
        cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
          cart {
            ${CART_FIELDS}
          }
          userErrors {
            field
            message
          }
        }
      }`
      const variables = {
        attributes: await getCustomAttributesWithTimeout(1000),
        cartId: this.cart.id
      }

      const result = await shopifyRequest(query, variables)
      this.setCartValues(result.cartAttributesUpdate.cart)

      this.goToCheckout()
    }
    catch(e) {
      console.log(e)
      window.location.href = this.cart.checkoutUrl
    }
  },
  async getVariant(id) {
    const query = `query productVariant($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          id
          title
          sku
          price {
            amount
          }
          product {
            id
            title
            productType
            vendor
          }
        }
      }
    }`
    const variables = {
      id: id,
    }
    

    const result = await shopifyRequest(query, variables)
    return result.node
  },
  variantMapFields(variant) {
    return {
      id: variant.product.id.replace('gid://shopify/Product/', ''),
      item_id: variant.product.id.replace('gid://shopify/Product/', ''),
      item_sku: variant.sku,
      item_name: variant.product.title,
      item_variant: variant.title,
      price: variant.price.amount,
      currency: 'EUR',
      item_category: variant.product.productType,
      item_brand: variant.product.vendor
    }
  },
  async getVariantDatalayerFields(id) {
    const variant = await this.getVariant(id)
    return this.variantMapFields(variant)
  },
  async updateCartLine (node, quantity) {
    const query = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          ${CART_FIELDS}
        }
        userErrors {
          field
          message
        }
      }
    }`
    const variables = {
      cartId: this.cart.id,
      lines: [
        {
          id: node.id,
          quantity: Number(quantity),
        },
      ],
    }

    const result = await shopifyRequest(query, variables)
    this.setCartValues(result.cartLinesUpdate.cart)

    const variantFields = await this.getVariantDatalayerFields(node.merchandise.id)

    dataLayerEcomPush({
      eventName: 'update_cart',
      variantFields: variantFields,
      quantity: quantity
    })
  },
  async removeCartLine (node) {
    const query = `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart {
          ${CART_FIELDS}
        }
        userErrors {
          field
          message
        }
      }
    }`
    const variables = {
      cartId: this.cart.id,
      lineIds: [node.id]
    }

    const result = await shopifyRequest(query, variables)
    this.setCartValues(result.cartLinesRemove.cart)

    const variantFields = await this.getVariantDatalayerFields(node.merchandise.id)

    dataLayerEcomPush({
      eventName: 'remove_from_cart',
      variantFields: variantFields,
      quantity: node.quantity
    })
  },
  async viewItemEvent(eventName, variantID) {
    const variantFields = await this.getVariantDatalayerFields(variantID)

    dataLayerEcomPush({
      eventName: eventName,
      variantFields: variantFields,
      quantity: 1
    })

  },
  async addToCart (data) {
    if (this.cart.id === '') {
      await this.createCart()
    }
    const query = `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          ${CART_FIELDS}
        }
        userErrors {
          field
          message
        }
      }
    }`

    const variables = {
      cartId: this.cart.id,
      lines: [
        {
          quantity: 1,
          merchandiseId: data.merchandiseId,
        },
      ],
    }

    const result = await shopifyRequest(query, variables)

    this.setCartValues(result.cartLinesAdd.cart)

    this.activePanel = 'add-to-cart-success'

    const evt = new CustomEvent("cart-success", {
      detail: {
        productId: data.productId,
        title: data.title,
        merchandiseId: data.merchandiseId,
      }
    });
    window.dispatchEvent(evt);

    const variantFields = await this.getVariantDatalayerFields(data.merchandiseId)

    dataLayerEcomPush({
      eventName: 'add_to_cart',
      variantFields: variantFields,
      quantity: 1
    })

  }
})

Alpine.data('search', (inline) => ({
  productResults: [],
  collectionResults: [],
  pageResults: [],
  queryInput: '',
  hide: false,
  loaded: false,
  closed: true,
  init() {
    if (!inline) {
      this.$watch('queryInput', (val) => {
        if (val) {
          if (this.closed === false) {
            this.$store.shop.activePanel = 'search-results'
          }
        } 
        if (!val) {
          this.$store.shop.activePanel = ''
        }
      })
    }
  },
  clickHandler(url) {
    try {
      window.dataLayer.push({
        'event' : 'searchResultClick',
        'searchTerm': this.queryInput,
        'targetUrl': url,
        'eventCallback' : function() {
          window.location.href = url
        },
        'eventTimeout' : 2000
      });
    }
    catch {
      window.location.href = url
    }
  },
  aandoeningLinkResolver(item) {
    if (!item.IsAandoening) {
      return '/collecties/' + item.Handle
    }
    let prefix = '/aandoening-of-blessure/'
    if (item.Hoofdcollectie) {
      prefix = `/aandoening-of-blessure/${item.Hoofdcollectie}/`
    }
    return `${prefix}${item.Handle}`
  },
  anyResults() {
    return this.productResults.length > 0 || this.collectionResults.length > 0 || this.pageResults.length > 0
  },
  close() {
    this.closed = true
    this.$refs.searchinput.blur()
    this.$store.shop.activePanel = ''
  },
  open() {
    if (this.anyResults()) {
      this.$store.shop.activePanel = 'search-results'
    }
  },
  async runSearch() {
    this.loaded = false
    await Promise.all([
      this.productSearch(),
      this.collectionSearch(),
      this.pageSearch()
    ])
    this.loaded = true

    if (this.anyResults()) {
      dataLayerPush({
        event: 'search',
        searchTerm: this.queryInput,
        searchResults: {
          products: this.productResults.length,
          collections: this.collectionResults.length,
          pages: this.pageResults.length
        }
      })
    }
  },
  async collectionSearch() {
    const response = await fetch(`/collecties/search?q=${this.queryInput}&limit=3`)
    const data = await response.json()
    this.collectionResults = data
  },
  async pageSearch() {
    const response = await fetch(`/page/search?q=${this.queryInput}&limit=3`)
    const data = await response.json()
    this.pageResults = data
  },
  async productSearch() {
    const query = `query search($query: String!) {
      products(first: 3, query: $query) {
        edges {
          node {
            id
            handle
            title
            featuredImage {
              cropped: transformedSrc(maxHeight: 180, maxWidth: 180, crop: CENTER)
              altText
              height
              width
              url
            }
            priceRange {
              minVariantPrice {
                amount
              }
            }
          }
        }
      }
    }`
    const variables = {
      query: this.queryInput,
    }

    const result = await shopifyRequest(query, variables)
    this.productResults = result.products.edges
  }
}))

Alpine.data('collection', (handle) => ({
  activeFilters: [],
  async loadProds(obj) {
    const url = new URL(window.location.href)
    url.pathname = '/fragments/collection-products/' + handle
    if (obj.end_cursor) {
      url.searchParams.set('end_cursor', obj.end_cursor)
    }
    await htmx.ajax('GET', url.href, {target:'#collection-product-list', swap:'beforeend', select: '#collection-product-list .product-card', source: '#load-more-button'})
  },
  removeFilter(filter) {
    this.activeFilters = this.activeFilters.filter((item) => item !== filter)
  }
}))

Alpine.data('fixedAddToCartButton', () => ({
  isFixed: false,
  navigationHandler() {
    const addToCartButton = this.$el.querySelector('.add-to-cart-button')
    if (addToCartButton) {
      if (window.scrollY >= (addToCartButton.offsetTop)) {
        this.isFixed = true
      }
      else {
        this.isFixed = false
      }
    }
  },
  init () {
    this.navigationHandler()
    document.addEventListener('scroll', () => {
        this.navigationHandler()
    });
  }
}))


Alpine.data('buttonSpinner', () => ({
  loading: false,
  oldHTML: '',
  svg: `<svg aria-hidden="true" class="btn-spinner w-5 h-5 text-dark-green animate-spin  fill-dark-blue" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
  </svg>
`,
  async loadFunc(func) {
      this.loading = true
      await func
      this.loading = false
  },
  init () {
      this.$watch('loading', (val) => {
        if (val) {
          const hasImag = this.$el.querySelector('img')
          if (hasImag) {
            this.oldHTML = hasImag.outerHTML
            hasImag.outerHTML = this.svg
          }
          else {
            this.insertedEl = this.$el.insertAdjacentHTML('beforeend', this.svg)
           
          }
          this.$el.disabled = true;
        }
        else {
          if (this.oldHTML) {
            this.$el.querySelector('.btn-spinner').outerHTML = this.oldHTML
          }
          else {
            this.$el.querySelector('.btn-spinner').remove()
          }
          this.$el.disabled = false;
        }
      })
  }
}))

Alpine.start()